import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import { BsSearch } from "react-icons/bs";
// import DisabledVisibleIcon from "@mui/icons-material/DisabledVisible";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

const columns = [
  {
    field: "reqnum",
    headerName: "REQNUM",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div className="flex items-center justify-center h-full">
        {params.value}
      </div>
    ),
  },
  {
    field: "term",
    headerName: "TERM",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div className="flex items-center justify-center h-full">
        {params.value}
      </div>
    ),
  },
  {
    field: "class",
    headerName: "CLASS",
    flex: 2,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div className="flex items-center justify-center h-full">
        {params.value}
      </div>
    ),
  },
  {
    field: "instructor",
    headerName: "INSTRUCTOR",
    flex: 2,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div className="flex items-center justify-center h-full">
        {params.value}
      </div>
    ),
  },
  {
    field: "question",
    headerName: "QUESTION",
    flex: 3,
    align: "left",
    headerAlign: "center",
    renderCell: (params) => (
      <div className="flex items-center justify-start h-full">
        {params.value}
      </div>
    ),
  },
  {
    field: "comment",
    headerName: "COMMENT",
    flex: 6,
    align: "left",
    headerAlign: "center",
    renderCell: (params) => (
      <div className="flex items-center justify-start h-full">
        {params.value}
      </div>
    ),
  },
  {
    field: "redacted",
    headerName: "REDACTED",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div className="flex items-center justify-center h-full">
        {params.value}
      </div>
    ),
  },
];
const pageHeight = `calc(100vh - calc(13rem + 8px))`;

export default function RedactReportComments() {
  const [ddcInfoFetched, setDdcInfoFetched] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(true);
  const [loadingBar, setLoadingBar] = useState(false); // To show/hide loading bar
  const [loaded, setLoaded] = useState(false);

  const [terms, setTerms] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [dnameList, setDnameList] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedDeptID, setSelectedDeptID] = useState([]);
  const [reqnum, setReqnum] = useState("");
  const [clsnum, setClsnum] = useState("");

  const [commentData, setCommentData] = useState([]);
  const [selectionModel, setSelectionModel] = useState({
    type: "include",
    ids: new Set(),
  });
  const [updateWarning, setUpdateWarning] = useState(false);

  const isSearchValid = !(
    selectedTerm !== null &&
    (selectedDeptID.length > 0 ||
      reqnum !== "" ||
      (clsnum !== "" && reqnum !== ""))
  );

  const isRedactValid = !(
    selectionModel.ids.size > 0 &&
    Array.from(selectionModel.ids).every((id) => {
      const row = commentData.find((r) => r.id === id);
      return row?.redacted === "N";
    })
  );

  const isUnredactValid = !(
    selectionModel.ids.size > 0 &&
    Array.from(selectionModel.ids).every((id) => {
      const row = commentData.find((r) => r.id === id);
      return row?.redacted === "Y";
    })
  );

  useEffect(() => {
    let url = process.env.REACT_APP_BACKEND_HOST;
    async function ddc_info() {
      const response = await fetch(
        url.concat("/spot/ddc_info/", sessionStorage.ccid, "/"),
        {
          headers: { Authorization: `Token ${sessionStorage.token}` },
        },
      );
      const apiData = await response.json();
      setDdcInfoFetched(true);
      return apiData;
    }

    if (!ddcInfoFetched) {
      let apiData = [ddc_info()];
      Promise.all(apiData).then((values) => {
        let data = values[0];
        let term_list = data.terms
          .slice()
          .sort((a, b) => b[0] - a[0])
          .map((item) => item[0].toString().concat(" - ", item[1].toString()));
        setSelectedTerm(term_list[0]);
        setTerms(term_list);

        let departments = data.depts.slice().sort((a, b) => b[1] - a[1]);
        // .map((item) => item[1].toString());
        let dname_list = departments.map((item) => item[1].toString());
        setDepartmentList(departments);
        setDnameList(dname_list);
        setLoaded(true);
      });
    }

    if (loaded && loadingFilters) {
      setTimeout(() => {
        setLoadingFilters(false);
      }, 3000);
    }
  }, [loaded, loadingFilters, ddcInfoFetched]);

  const handleTermChange = (event, newValue) => {
    setSelectedTerm(newValue);
  };

  const handleDepartmentChange = (event, newValue) => {
    setSelectedDepartment(newValue);
    const deptIDs = newValue
      .map((value) => departmentList.find((item) => item[1] === value)?.[0])
      .filter(Boolean);
    setSelectedDeptID(deptIDs);
  };

  async function fetch_comments() {
    setLoadingBar(true);
    let url = process.env.REACT_APP_BACKEND_HOST;
    const filters = {
      empids: sessionStorage.getItem("viewable_empids"),
      term: Number(selectedTerm.split("-")[0].trim()),
      deptIDs: selectedDeptID,
      reqnum: reqnum,
      clsnum: clsnum,
      user: sessionStorage.getItem("ccid"),
    };

    const response = await fetch(url.concat("/spot/get_flagged_comments/"), {
      method: "POST",
      headers: {
        Authorization: `Token ${sessionStorage.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(filters),
    });
    const apiData = await response.json();
    let data = [];
    apiData.map((item) => {
      let entry = {
        id: item.id,
        reqnum: item.reqnum,
        term: item.term,
        class: item.class,
        instructor: item.instructor,
        question: item.question,
        comment: item.comment,
        flagged: item.flagged,
        redacted: item.redacted,
      };
      data.push(entry);
    });
    setCommentData(data);
    setHasSearched(true);
    setLoadingBar(false);
  }

  const handleSelectionModelChange = (newSelection) => {
    if (newSelection.type === "exclude") {
      const allRowIds = commentData.map((row) => row.id);

      const includedIds = allRowIds.filter((id) => !newSelection.ids.has(id));

      setSelectionModel({
        type: "include",
        ids: new Set(includedIds),
      });
    } else {
      setSelectionModel(newSelection);
    }
  };

  function warningUpdateMessage() {
    setUpdateWarning(true);
  }

  function cancelRedactComment() {
    setUpdateWarning(false);
    console.log("CANCELING REDACTING COMMENT(S)");
  }

  async function redact_comments() {
    setUpdateWarning(false);
    setSelectionModel({ type: "include", ids: new Set() });
    setLoadingBar(true);
    let update_data = {};
    if (!isRedactValid) {
      update_data = {
        comment_id: [...selectionModel.ids],
        updateType: "Y",
        user: sessionStorage.getItem("ccid"),
      };
    } else if (!isUnredactValid) {
      update_data = {
        comment_id: [...selectionModel.ids],
        updateType: "N",
        user: sessionStorage.getItem("ccid"),
      };
    }

    const response = await fetch(
      process.env.REACT_APP_BACKEND_HOST.concat("/spot/redact_comments/"),
      {
        method: "PUT",
        headers: {
          Authorization: `Token ${sessionStorage.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(update_data),
      },
    );
    const update_status = await response.json();
    // console.log(update_status)
    await new Promise((resolve) => setTimeout(resolve, 2000));
    fetch_comments();
  }

  return (
    <Box
      sx={{
        // border: "2px solid rgba(0, 255, 0, 1)",
        display: "flex",
        flexDirection: "column",
        height: pageHeight,
        backgroundColor: "#F5F5F5",
        paddingY: 2,
        paddingX: 4,
      }}
    >
      <Box
        sx={{
          // height: filterHeight,
          width: "100%",
          // border: "2px solid rgba(0, 0, 0, 1)",
          display: "flex",
          flexDirection: "row",
          position: "relative",
          paddingBottom: 2,
          gap: 2,
        }}
      >
        <Autocomplete
          value={selectedTerm}
          onChange={handleTermChange}
          size="small"
          options={terms}
          sx={{ width: "15%" }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="TERM"
              sx={{ backgroundColor: "#fff" }}
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingFilters && (
                        <CircularProgress color="inherit" size={20} />
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                },
              }}
            />
          )}
        />
        <Autocomplete
          multiple
          limitTags={3}
          // value={selectecDepartment}
          onChange={handleDepartmentChange}
          size="small"
          options={dnameList}
          sx={{ width: "45%" }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="DEPARTMENT"
              sx={{ backgroundColor: "#fff" }}
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingFilters && (
                        <CircularProgress color="inherit" size={20} />
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                },
              }}
            />
          )}
        />
        <TextField
          label="REQNUM"
          size="small"
          value={reqnum}
          onChange={(e) => {
            // digits only
            setReqnum(e.target.value.replace(/\D/g, ""));
          }}
          sx={{
            width: "10%",
            "& .MuiInputBase-root": {
              backgroundColor: "#fff",
            },
          }}
        />

        <TextField
          label="CLSNUM"
          size="small"
          value={clsnum}
          onChange={(e) => {
            // digits only
            setClsnum(e.target.value.replace(/\D/g, ""));
          }}
          sx={{
            width: "10%",
            "& .MuiInputBase-root": {
              backgroundColor: "#fff",
            },
          }}
        />

        <Button
          type="submit"
          variant="contained"
          size="small"
          onClick={fetch_comments}
          disabled={isSearchValid}
          sx={{
            width: "20%",
            backgroundColor: "#275d38",
            "&.Mui-disabled": {
              backgroundColor: "#ccc",
              color: "#666",
            },
          }}
          endIcon={<BsSearch />}
        >
          <Typography style={{ fontSize: "16px" }}>Search Comments</Typography>
        </Button>
      </Box>
      <Box
        sx={{
          // height:"85%",
          height: `calc(${pageHeight} - ${82}px - ${64}px)`,
          width: "100%",
          // border: "2px solid rgba(255, 0, 0, 1)",
          position: "relative",
        }}
      >
        <div style={{ position: "relative", height: "100%", width: "100%" }}>
          {!hasSearched && (
            <div className="absolute inset-0 z-20 bg-black bg-opacity-30 flex items-center justify-center">
              <div className="bg-primary rounded-xl w-[32dvw] p-10 text-primaryGold shadow-xl">
                <h2 className="mb-4 text-center text-xl font-bold">
                  Search Requirements
                </h2>

                <div className="space-y-3 text-center">
                  <p className="text-lg font-semibold">
                    Select a Term, then choose at least one Department or enter
                    a Reqnum (with or without CLSNUM).
                  </p>

                  <p className="text-lg font-semibold">
                    Click "Search Comments" to continue.
                  </p>
                </div>
              </div>
            </div>
          )}
          <DataGrid
            // disableColumnSorting
            getRowId={(row) => row.id}
            rows={commentData}
            columns={columns}
            getRowHeight={() => "auto"}
            checkboxSelection
            density="compact"
            loading={loadingBar}
            pageSizeOptions={[100]}
            getRowClassName={(params) => {
              const flagged = String(params.row.flagged ?? "")
                .trim()
                .toUpperCase();
              const redacted = String(params.row.redacted ?? "")
                .trim()
                .toUpperCase();
              const classes = [];
              if (flagged === "Y") classes.push("row-flagged");
              if (redacted === "Y") classes.push("row-redacted");

              return classes.join(" ");
            }}
            rowSelectionModel={selectionModel}
            onRowSelectionModelChange={handleSelectionModelChange}
            keepNonExistentRowsSelected={false}
            sx={{
              height: "100%",
              width: "100%",
              "& .highlight": { color: "red" },
              "& .MuiDataGrid-cell": { py: 2 },
              // flagged = yellow background
              "& .row-flagged .MuiDataGrid-cell": {
                backgroundColor: "#fff3cd",
              },
              // redacted = strikethrough + muted
              "& .row-redacted .MuiDataGrid-cell": {
                textDecoration: "line-through",
                color: "#6c757d",
              },
            }}
          />
          <Dialog
            class="Edit Warning"
            open={updateWarning}
            fullWidth={true}
            maxWidth={"md"}
          >
            <DialogContent
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                gap: 2,
              }}
            >
              <Typography fontSize={16} fontWeight={600}>
                {!isRedactValid
                  ? `ARE YOU SURE YOU WANT TO REDACT ${selectionModel.ids.size} COMMENTS?`
                  : !isUnredactValid
                    ? `ARE YOU SURE YOU WANT TO UNREDACT ${selectionModel.ids.size} COMMENTS?`
                    : ""}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  textAlign: "center",
                  gap: 2,
                }}
              >
                <Button
                  color="error"
                  variant="contained"
                  onClick={cancelRedactComment}
                  sx={{
                    width: "100%",
                    // backgroundColor: "#275d38",
                    "&.Mui-disabled": {
                      backgroundColor: "#ccc",
                      color: "#666",
                    },
                  }}
                >
                  <Typography fontSize={16}>NO</Typography>
                </Button>
                <Button
                  variant="contained"
                  onClick={redact_comments}
                  sx={{
                    width: "100%",
                    backgroundColor: "#275d38",
                    "&.Mui-disabled": {
                      backgroundColor: "#ccc",
                      color: "#666",
                    },
                  }}
                >
                  <Typography fontSize={16}>YES</Typography>
                </Button>
              </Box>
            </DialogContent>
          </Dialog>
        </div>
      </Box>
      <Box
        sx={{
          // height:"7%",
          width: "100%",
          // border: "2px solid rgba(0, 0, 0, 1)",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center", // horizontal center
          alignItems: "center", // vertical center
          position: "relative",
          paddingTop: 2,
          gap: 2,
        }}
      >
        <Button
          type="submit"
          variant="contained"
          size="medium"
          onClick={warningUpdateMessage}
          disabled={isUnredactValid}
          sx={{
            width: "20%",
            backgroundColor: "#275d38",
            "&.Mui-disabled": {
              backgroundColor: "#ccc",
              color: "#666",
            },
          }}
          endIcon={<VisibilityIcon />}
        >
          <Typography style={{ fontSize: "16px" }}>
            Unredact Comments
          </Typography>
        </Button>
        <Button
          color="error"
          type="submit"
          variant="contained"
          size="medium"
          onClick={warningUpdateMessage}
          disabled={isRedactValid}
          sx={{
            width: "20%",
            // backgroundColor: "#275d38",
            "&.Mui-disabled": {
              backgroundColor: "#ccc",
              color: "#666",
            },
          }}
          endIcon={<VisibilityOffIcon />}
        >
          <Typography style={{ fontSize: "16px" }}>Redact Comments</Typography>
        </Button>
      </Box>
    </Box>
  );
}
